import * as React from 'react';
import { Checkbox, CheckboxProps } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

/**
 * Reusable checkbox — idem mockup calculatie-alternativa-service_20.html (.cb):
 * 18x18, radius 5, 2px #C3CBD9 border, white bg; fills primary + white tick when checked.
 */
const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    width: 18,
    height: 18,
    borderRadius: 5,
    border: '2px solid #C3CBD9',
    backgroundColor: '#fff',
    'input:disabled ~ &': { border: 'none', background: theme.palette.grey[100] }
  },
  checkedIcon: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
    display: 'grid',
    placeItems: 'center',
    // Disabled + checked stays clearly filled (primary, just muted), not the faint grey default.
    'input:disabled ~ &': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.main,
      opacity: 0.5
    },
    '&:before': {
      display: 'block',
      width: 13,
      height: 13,
      content: '""',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")"
    }
  }
}));

const CustomCheckbox: React.FC<CheckboxProps> = (props) => {
  const classes = useStyles();
  return (
    <Checkbox
      disableRipple
      color="default"
      icon={<span className={classes.icon} />}
      checkedIcon={<span className={`${classes.icon} ${classes.checkedIcon}`} />}
      {...props}
    />
  );
};

export default CustomCheckbox;
